(function(){
'use strict';

/**
 * This service loads member data from the /frs-api/me endpoint.
 *
 * It ensures that member data is fetched and set in SC.member during page initialization
 * for pages that need member data to be cacheable (like /give endpoints).
 *
 * This service maintains backward compatibility by checking if SC.member is already set
 * before making API calls, allowing existing server-side member loading to continue working.
 *
 * @param $log
 * @param $http
 */
scMemberLoaderService.$inject = ["$log", "$http"];
function scMemberLoaderService($log, $http) {
  'use strict';

  var fetchMemberData = function fetchMemberData() {
    // If SC.member is already set (from server-side), use it
    if (typeof SC !== 'undefined' && SC.member && Object.keys(SC.member).length > 0) {
      return Promise.resolve(SC.member);
    }

    // Otherwise, fetch from API
    return $http.get('/frs-api/me').then(function (response) {
      var memberData = response && response.data ? response.data : {};
      return memberData;
    }).catch(function (error) {
      // Log the error but don't fail completely
      $log.error('Failed to fetch member data:', error);
      return {};
    });
  };

  return {
    fetchMemberData: fetchMemberData
  };
}

angular.module('classy').service('scMemberLoaderService', scMemberLoaderService);
})();